import React from 'react';

const SUIT_SYMBOLS = { hearts: '♥', diamonds: '♦', clubs: '♣', spades: '♠' };
const RED_SUITS = ['hearts', 'diamonds'];

/**
 * Card component.
 * Props:
 *   card     — card object { id, suit, rank, value } or { hidden: true }
 *   selected — boolean, highlights the card
 *   onClick  — click handler
 *   size     — 'sm' | 'md' (default 'md')
 */
const Card = ({ card, selected = false, onClick, size = 'md' }) => {
  if (!card) return null;

  if (card.hidden) {
    return (
      <div className={`card card-back card--${size}`} onClick={onClick}>
        <div className="card-back-pattern">🕯</div>
      </div>
    );
  }

  const isRed = RED_SUITS.includes(card.suit);
  return (
    <div
      className={`card card--${size} ${isRed ? 'card--red' : 'card--black'} ${selected ? 'card--selected' : ''}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <span className="card-rank">{card.rank}</span>
      <span className="card-suit">{SUIT_SYMBOLS[card.suit]}</span>
    </div>
  );
};

export default Card;
